import React from 'react';

const SearchContext = React.createContext({
    toggleSearch: () => null,
});

export default SearchContext;